import { createHook, createStore, type StoreActionApi } from 'react-sweet-state';

import { teamsClient } from '@atlaskit/teams-client';
import type { ReportingLines } from '@atlaskit/teams-client/types';

interface ReportingLinesStoreState {
	isLoading: boolean;
	error?: Error;
	selectedUserId: string | null;
	data?: {
		reportingLines: ReportingLines;
	};
}

const initialState: ReportingLinesStoreState = {
	isLoading: false,
	data: undefined,
	error: undefined,
	selectedUserId: null,
};
type StoreApi = StoreActionApi<ReportingLinesStoreState>;
type Actions = typeof actions;

export const actions = {
	getReportingLines:
		(teamId: string) =>
		async ({ setState }: StoreApi): Promise<void> => {
			setState({
				isLoading: true,
			});
			try {
				const data = await teamsClient.getReportingLines(teamId);
				setState({
					isLoading: false,
					data,
				});
			} catch (e) {
				setState({
					isLoading: false,
					error: e instanceof Error ? e : new Error(String(e)),
				});
			}
		},
	selectUser:
		(userId: string) =>
		({ setState }: StoreApi): void => {
			setState({ selectedUserId: userId });
		},
};

const ReportingLinesStore = createStore<ReportingLinesStoreState, Actions>({
	initialState,
	actions,
});

export const useReportingLinesStore = createHook(ReportingLinesStore);
